export default {
  install(Vue,options)
  {
    // Vue.prototype.baseUrl = 'https://t.qiqueqiao.com';
    Vue.prototype.baseUrl = 'https://q.qiqueqiao.com';
  }
}



// WEBPACK FOOTER //
// ./src/libs/config/config.js